import { styled } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

export const Container = styled('div')(({ theme }) => ({
  margin: '0 auto',
  marginBottom: '2rem',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: '2rem',
  maxWidth: '40rem',
}));

export const ContainerStores = styled('div')(({ theme }) => ({
  border: `.1rem solid ${theme.palette.secondary.dark}`,
  borderRadius: '0.5rem',
}));

export const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignContent: 'center',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '.5rem',
  padding: '.9rem',
  borderBottom: `.1rem solid ${theme.palette.secondary.dark}`,
  backgroundColor: `${theme.palette.primary.main}`,
  borderRadius: '0.5rem 0.5rem 0 0',
  marginBottom: '1rem',
}));

export const AlignLeft = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '.5rem',
}));

export const Content = styled('div')(() => ({
  padding: '0rem 0.9rem 1rem 0.9rem',
}));

export const DivBreakWord = styled('div')(() => ({
  overflowWrap: 'break-word',
}));

export const EditIconStyled = styled(EditOutlinedIcon)(() => ({
  cursor: 'pointer',
}));
